import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTenant } from '../context/TenantContext';
import { useAuth } from '../context/AuthContext';
import { communityNavigation } from '../utils/communityNavigation';

/**
 * TenantDashboardPage — community overview for the /t/:tenantSlug/dashboard route.
 *
 * Accessible to platform staff (viewing any community) and active community members.
 * Data comes from TenantContext (viewTenant) rather than AuthContext.activeTenant.
 */
const TenantDashboardPage = () => {
  const { tenantSlug } = useParams();
  const { viewTenant, viewerRole, isPlatformStaff, isViewModuleEnabled } = useTenant();
  const { user } = useAuth();
  const moduleTiles = communityNavigation({
    base: `/t/${tenantSlug}`, tenantId: viewTenant?._id, user, role: viewerRole, enabled: isViewModuleEnabled,
  }).slice(1).flatMap((item) => item.children || [item]);

  const displayName = viewTenant?.branding?.displayName || viewTenant?.name || tenantSlug;
  const primaryColor = viewTenant?.branding?.primaryColor || '#0ea5e9';

  return (
    <div className="page dashboard-page">
      <div className="page-header">
        <h1 style={{ borderLeft: `4px solid ${primaryColor}`, paddingLeft: 12 }}>
          {displayName}
        </h1>
        {viewTenant?.description && (
          <p style={{ color: '#94a3b8', marginTop: 4 }}>{viewTenant.description}</p>
        )}
        {isPlatformStaff && viewerRole && (
          <span className="badge badge-gray" style={{ fontSize: 11, marginTop: 8 }}>
            Viewing as {viewerRole}
          </span>
        )}
      </div>

      {viewTenant?.communityHomeText && (
        <section className="community-home-message" aria-label="Community welcome">
          <h2>Welcome to {displayName}</h2>
          <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{viewTenant.communityHomeText}</p>
        </section>
      )}

      {/* Module quick-links */}
      {moduleTiles.length > 0 && (
        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 13, fontWeight: 700, color: '#64748b', letterSpacing: 0.5, marginBottom: 10 }}>
            YOUR COMMUNITY TOOLS
          </h2>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            {moduleTiles.map(({ to, label, icon }) => (
              <Link
                key={to}
                to={to}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  background: '#0f172a',
                  border: '1px solid #1e293b',
                  borderRadius: 8,
                  padding: '8px 16px',
                  color: '#e2e8f0',
                  textDecoration: 'none',
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                {icon} {label}
              </Link>
            ))}
          </div>
        </section>
      )}

    </div>
  );
};

export default TenantDashboardPage;
